import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { pluck } from "rxjs/operators";
import { AppState } from "src/app/store/state/app.state";
import { GlobalHeaderDataService } from "../global-header-data.service";
import * as Action from "../../store/actions/global-header.actions";
import { SetGlobalSettingModalVisibility } from "src/app/store/actions/global-user-settings.actions";
import { VAIconRegistryService, user } from "@va/core-library/icons";
@Component({
  selector: "app-global-user-menu",
  templateUrl: "./global-user-menu.component.html",
  styleUrls: ["./global-user-menu.component.scss"],
})
export class GlobalUserMenuComponent implements OnInit {
  legacyUrl = `${window.caUrl}/app`;
  legacyDomain = window.caUrl;
  projectArkUrl = window.projectArkUrl;

  globalSettings: any = {};
  isUserSelected = false;
  globalSettingsData: any = {};
  constructor(
    private store: Store<AppState>,
    private router: Router,
    private dataService: GlobalHeaderDataService,
    private iconRegistry: VAIconRegistryService,
  ) {
    store
      .select("globalHeader")
      .pipe(pluck("globalSettings"))
      .subscribe((data: AppState) => {
        this.globalSettings = data;
      });
    this.iconRegistry.registerIcons([user]);
  }

  ngOnInit(): void {
    this.router.events.subscribe(() => {
      this.isOpen(false);
    });

    this.dataService.getUserSettings().subscribe((resp) => {
      if (resp["status"] === "success") {
        this.store.dispatch(new Action.SetGlobalAppSettings(resp["data"]));
        this.globalSettingsData = resp["data"];
      }
    });
  }

  onClickGlobalSettings(): void {
    this.store.dispatch(new SetGlobalSettingModalVisibility(true));
  }

  isOpen(nzVisible) {
    this.isUserSelected = nzVisible;
  }
}
